(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const initDesktopHoverMenus = () => {
    const mq = window.matchMedia('(min-width: 990px)');
    const header = document.querySelector('.section-header');
    if (!header) return;

    const detailsList = header.querySelectorAll('.header__inline-menu details');

    detailsList.forEach((details) => {
      if (details.dataset.hoverBound === 'true') return;
      details.dataset.hoverBound = 'true';

      const summary = details.querySelector('summary');

      const openThis = () => {
        if (!mq.matches) return;

        header.querySelectorAll('.header-language-wrapper--desktop details').forEach((languageDetails) => {
          languageDetails.removeAttribute('open');
          const languageSummary = languageDetails.querySelector('summary');
          if (languageSummary) languageSummary.setAttribute('aria-expanded', 'false');
        });

        detailsList.forEach((d) => {
          if (d !== details) {
            d.removeAttribute('open');
            const s = d.querySelector('summary');
            if (s) s.setAttribute('aria-expanded', 'false');
          }
        });

        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      };

      const closeThis = () => {
        if (!mq.matches) return;
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      };

      details.addEventListener('mouseenter', openThis);
      details.addEventListener('mouseleave', closeThis);

      details.addEventListener('focusin', openThis);
      details.addEventListener('focusout', (event) => {
        if (!mq.matches) return;
        if (!details.contains(event.relatedTarget)) closeThis();
      });
    });
  };

  const initDesktopParentSummaryNavigation = () => {
    const mq = window.matchMedia('(min-width: 990px)');
    const header = document.querySelector('.section-header');
    if (!header) return;

    const urlMap = window.__HEADER_PARENT_LINK_URLS__ || {};
    const summaries = header.querySelectorAll('.header__inline-menu details > summary');

    summaries.forEach((summary) => {
      if (summary.dataset.parentNavBound === 'true') return;
      summary.dataset.parentNavBound = 'true';

      summary.addEventListener('click', (e) => {
        if (!mq.matches) return;

        if (e.target.closest('.icon-caret, .icon-caret *, .header-language-selector__caret, .header-language-selector__caret *')) return;

        const titleEl = summary.querySelector('span');
        const title = (titleEl ? titleEl.textContent : summary.textContent).trim();

        const targetUrl = urlMap[title];
        if (!targetUrl) return;

        e.preventDefault();
        window.location.href = targetUrl;
      });
    });
  };

  const initDesktopLanguageSelector = () => {
    const mq = window.matchMedia('(min-width: 990px)');
    const header = document.querySelector('.section-header');
    if (!header) return;

    const languageDetails = header.querySelectorAll('.header-language-wrapper--desktop details');

    languageDetails.forEach((details) => {
      if (details.dataset.languageHoverBound === 'true') return;
      details.dataset.languageHoverBound = 'true';

      const summary = details.querySelector('summary');
      let languageCloseTimer = null;

      const clearLanguageCloseTimer = () => {
        if (languageCloseTimer) {
          window.clearTimeout(languageCloseTimer);
          languageCloseTimer = null;
        }
      };

      const openThis = () => {
        if (!mq.matches) return;

        clearLanguageCloseTimer();

        header.querySelectorAll('.header__inline-menu details').forEach((d) => {
          d.removeAttribute('open');
          const s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        });

        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      };

      const closeThis = () => {
        if (!mq.matches) return;

        clearLanguageCloseTimer();

        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      };

      const closeThisWithDelay = () => {
        if (!mq.matches) return;

        clearLanguageCloseTimer();

        languageCloseTimer = window.setTimeout(() => {
          closeThis();
        }, 200);
      };

      details.addEventListener('mouseenter', openThis);
      details.addEventListener('mouseleave', closeThisWithDelay);

      details.addEventListener('focusin', openThis);
      details.addEventListener('focusout', (event) => {
        if (!mq.matches) return;
        if (!details.contains(event.relatedTarget)) closeThisWithDelay();
      });
    });
  };

  const initMobileLanguageSelectorCloseOnSelect = () => {
    const header = document.querySelector('.section-header');
    if (!header) return;

    const buttons = header.querySelectorAll('.header-language-wrapper--mobile .header-language-selector__button');

    buttons.forEach((button) => {
      if (button.dataset.mobileLanguageCloseBound === 'true') return;
      button.dataset.mobileLanguageCloseBound = 'true';

      button.addEventListener('click', () => {
        const details = button.closest('details');
        if (!details) return;

        /*
          ✅ 移动端修复：
          不要在 click 的默认提交动作之前立刻关闭 details。
          立刻 removeAttribute('open') 在部分手机浏览器上会导致第一次点击只关闭/聚焦，
          第二次点击才真正提交 localization 表单。
        */
        window.setTimeout(() => {
          details.removeAttribute('open');

          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 300);
      });
    });
  };

  const initMobileDrawerWhiteHeader = () => {
    const mq = window.matchMedia('(max-width: 989px)');
    const header = document.querySelector('.section-header');
    if (!header) return;

    const drawerDetails = header.querySelector('header-drawer details');
    if (!drawerDetails) return;

    if (drawerDetails.dataset.whiteHeaderBound === 'true') return;
    drawerDetails.dataset.whiteHeaderBound = 'true';

    const summary = drawerDetails.querySelector('summary');
    let closingStarted = false;

    const isDrawerOpenLike = () => {
      return drawerDetails.hasAttribute('open') || drawerDetails.classList.contains('menu-opening');
    };

    const showWhiteHeader = () => {
      if (!mq.matches) return;
      header.classList.add('mobile-menu-open');
    };

    const hideWhiteHeader = () => {
      header.classList.remove('mobile-menu-open');
    };

    const startClosingImmediately = () => {
      closingStarted = true;
      hideWhiteHeader();
    };

    const syncMobileDrawerHeader = () => {
      if (!mq.matches) {
        closingStarted = false;
        hideWhiteHeader();
        return;
      }

      const openLike = isDrawerOpenLike();

      if (!openLike) {
        closingStarted = false;
        hideWhiteHeader();
        return;
      }

      if (closingStarted) {
        hideWhiteHeader();
        return;
      }

      showWhiteHeader();
    };

    if (summary) {
      summary.addEventListener(
        'click',
        () => {
          if (!mq.matches) return;

          if (isDrawerOpenLike()) {
            startClosingImmediately();
          } else {
            closingStarted = false;
            showWhiteHeader();
          }
        },
        true
      );
    }

    drawerDetails.addEventListener('toggle', syncMobileDrawerHeader);

    document.addEventListener(
      'keyup',
      (event) => {
        if (!mq.matches) return;
        if (event.key !== 'Escape' && event.code !== 'Escape') return;

        if (isDrawerOpenLike()) {
          startClosingImmediately();
        }
      },
      true
    );

    const observer = new MutationObserver(syncMobileDrawerHeader);
    observer.observe(drawerDetails, {
      attributes: true,
      attributeFilter: ['open', 'class']
    });

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', syncMobileDrawerHeader);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(syncMobileDrawerHeader);
    }

    syncMobileDrawerHeader();
  };

  initDesktopHoverMenus();
  initDesktopParentSummaryNavigation();
  initDesktopLanguageSelector();
  initMobileLanguageSelectorCloseOnSelect();
  initMobileDrawerWhiteHeader();

  document.addEventListener('shopify:section:load', () => {
    initDesktopHoverMenus();
    initDesktopParentSummaryNavigation();
    initDesktopLanguageSelector();
    initMobileLanguageSelectorCloseOnSelect();
    initMobileDrawerWhiteHeader();
  });

  } catch(e) { console.error(e); }
})();
})();
